import { F0AvatarModule, F0Box, F0Button, OneEllipsis, type ModuleId } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export type FormHeaderProps = {
  title: string
  description?: string
  module?: ModuleId
  onClose: () => void
}

export function FormHeader({ title, description, module, onClose }: FormHeaderProps) {
  return (
    <F0Box
      display="flex"
      alignItems="center"
      gap="lg"
      shrink={false}
      border="none"
      borderBottom="default"
      borderColor="secondary"
      padding="md"
      paddingLeft="lg"
    >
      {module && <F0AvatarModule module={module} size="lg" />}
      <F0Box minWidth="0" grow>
        <OneEllipsis tag="h2" className="text-lg font-semibold text-f1-foreground">
          {title}
        </OneEllipsis>
        {description && (
          <OneEllipsis className="truncate text-base text-f1-foreground-secondary">
            {description}
          </OneEllipsis>
        )}
      </F0Box>
      <F0Button
        variant="outline"
        size="md"
        icon={Cross}
        hideLabel
        onClick={onClose}
        label={i18n.t('common.ai.close_form')}
      />
    </F0Box>
  )
}
